import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg"><rect width={16} height={3.2} rx={1.6} fill="#fff" /><rect y={6.4} width={16} height={3.2} rx={1.6} fill="#fff" /><rect y={12.801} width={16} height={3.2} rx={1.6} fill="#fff" /></svg>;
}
export default SvgComponent;